import React from "react";

/** 天能AI 极简星标 LOGO：黑色四角星 + 苹果蓝点（与 AI 对话页/模块气泡同款）。inline SVG，随字号缩放。 */
const Logo: React.FC<{ size?: number; style?: React.CSSProperties }> = ({ size = 24, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg" style={{ display: "inline-block", verticalAlign: "middle", ...style }}
    role="img" aria-label="天能AI">
    <path d="M12 3l1.9 5.3L19 10l-5.1 1.7L12 17l-1.9-5.3L5 10l5.1-1.7L12 3z" fill="#1d1d1f" />
    <circle cx="18.6" cy="5.4" r="1.6" fill="#0071e3" />
  </svg>
);

export default Logo;
